import axiosInstance from './axiosInstance';

export async function getUsage() {
  const response = await axiosInstance.get('/api/usage', { withCredentials: true });
  return response?.data ?? null;
}

export async function fetchUsageSafe() {
  try {
    return await getUsage();
  } catch {
    return null;
  }
}
